import { useContext, useEffect, useMemo, useState } from "react";
import { Button, Dialog, TableSearch } from "@rio-cloud/rio-uikit";
import { DispatchedDriver } from "@types";
import { AuthContext } from "src/providers/AuthProvider";
import Avatar from "../../Avatar/indext";
import TableChip from "../../TableChip";

interface Props {
  open: boolean;
  onClose: () => void;
  drivers?: DispatchedDriver[] | null;
}

const normalizeText = (text: string): string =>
  text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

const DispatchedDrivers = ({ open, onClose, drivers }: Props) => {
  const { getDetailUser, finderDriverFleet } = useContext(AuthContext);

  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (!open) setSearchValue("");
  }, [open]);

  const list = drivers ?? [];

  const filteredList = useMemo(() => {
    if (!searchValue.trim()) return list;
    const term = normalizeText(searchValue);
    return list.filter((d) => normalizeText(d.driverName || "").includes(term));
  }, [list, searchValue]);

  return (
    <Dialog
      show={open}
      title={"Motoristas da viagem"}
      onClose={onClose}
      footer={
        <div className="display-flex gap-10 justify-content-end flex-grow">
          <Button bsSize={Button.MD} style={{ width: 84 }} onClick={onClose}>
            Voltar
          </Button>
        </div>
      }
      body={
        <div className="padding-15">
          <div className="margin-bottom-15">
            <TableSearch
              value={searchValue}
              onChange={setSearchValue}
              placeholder="Buscar motorista pelo nome"
            />
          </div>
          <div className="margin-bottom-15">
            <span className="text-bold text-size-16">
              {list.length} motorista{list.length !== 1 ? "s" : ""} nesta viagem
            </span>
          </div>

          {list.length === 0 ? (
            <div className="text-center text-color-gray padding-25">
              Nenhum motorista vinculado a esta viagem.
            </div>
          ) : filteredList.length === 0 ? (
            <div className="text-center text-color-gray padding-25">
              Nenhum motorista encontrado para "{searchValue}".
            </div>
          ) : (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
              }}
            >
              {filteredList.map((driver) => {
                const finder = finderDriverFleet?.(driver.driverId) as
                  | { uniqueProfileId?: string }
                  | undefined;
                const resolvedProfileId = driver.profileId || finder?.uniqueProfileId;
                const amity_user = getDetailUser?.(resolvedProfileId);

                return (
                  <div
                    key={driver.driverId}
                    className="display-flex flex-direction-row align-items-center padding-15 bg-lightest rounded border border-color-light"
                  >
                    <Avatar url={amity_user?.metadata?.imageProfile?.fileUrl} />
                    <div className="padding-x-15">
                      <span className="text-bold text-size-15 text-capitalize">
                        {driver.driverName}
                      </span>
                      <div className="margin-top-2">
                        <TableChip
                          disabledDriver={!finder}
                          disabledProfile={!resolvedProfileId}
                          user={amity_user}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      }
      className="dispatchedDriversDialog"
      showCloseButton
      bsSize="md"
    />
  );
};

export default DispatchedDrivers;
